export async function getLastDriverPaymentUseCase(repository, driverId) {
  return repository.getLastByDriverId(driverId);
}
